import { render } from "./NcrmMailjetActivityPanel.vue?vue&type=template&id=49347581&scoped=true"
import script from "./NcrmMailjetActivityPanel.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetActivityPanel.vue?vue&type=script&lang=js"

import "./NcrmMailjetActivityPanel.vue?vue&type=style&index=0&id=49347581&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49347581"]])

export default __exports__